<template>
    <div class="type-btns">
        <el-tabs class="tabs" v-model="newSelected" @tab-click="handleClick">
            <el-tab-pane v-for="(item,index) in newForm"
                         :key="index"
                         :label="item.value"
                         :name="item.key"
            ></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    export default {
        name: "type-btn",
        props: {
            form: {
                type: Array,
                default: ()=>{
                    return [
                        {key: '2',value: '公共'},
                        {key: '1',value: '我的'},
                    ]
                }
            },
            selected: [Number,String]
        },
        watch: {
            form:{
                handler(vl) {
                    let data = vl
                    // 如果为公共用户进来，因此我的
                    data.map(v => {
                        if (this.$store.getters.isPlat && `${v.key}` === '1') {
                            v.isShow = false
                        } else {
                            v.isShow = true
                        }
                    })
                    this.newForm = data
                },
                deep: true,
                immediate: true
            },
            newForm(vl){this.$emit('update:form',vl)},
            selected(vl){this.newSelected = vl},
            newSelected(vl){
                this.$emit('update:selected',vl)
            },
        },
        created () {
            // 如果当前为公共模版，则我的全部隐藏
            let isShop = this.$route.query.is_shop
            let isTemplate = this.$route.query.is_template
            if (isShop && isTemplate) {
                this.newForm = [{key: '2',value: '公共'}]
                this.newSelected = '2'
            }
        },
        data(){
            return {
                newForm: this.form,
                newSelected: this.selected
            }
        },
        methods: {
            handleClick(tab, event) {
                console.log('9090', tab, event);
                let item = {}
                this.newForm.map(v=>{
                    if(v.value === this.newSelected) {
                        item = v
                    }
                })
                this.$emit('onTypeBtn', item)
            },
            onTypeBtn(item){
                this.newSelected = item.key
                this.$emit('onTypeBtn', item)
            }
        }
    }
</script>
<style>
    .el-tabs__item.is-top {
        text-align: center;
        width: 122px;
        color: #323232 !important;
        font-weight: normal;
        /*width: 35px;*/
        /*left: 34px;*/
    }
    .el-tabs__item.is-top.is-active{
        /*color: #e7622e !important;*/
        background-color: rgba(0,0,0,0) !important;
        font-weight: bold;
    }
    .el-tabs__active-bar.is-top{
        background-color: rgba(0,0,0,0) !important;
        position: relative;
    }
    .el-tabs__active-bar.is-top:before{
        content: '';
        width: 36px;
        height: 2px;
        background-color: #e7622e;
        display: inline-block;
        position: absolute;
        left: 33px;
        bottom: -40px;
    }
    .el-tabs__nav-wrap::after{
        height: 1px !important;
    }
</style>
<style lang="scss" scoped>
.type-btns{
    margin-top: 10px;
    width: 100%;
    height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    /*background-color: #FAFAFA;*/
    margin-bottom: 16px;

    .tabs{
        width: 100%;
    }

    .btn{
        font-size: 16px;
        color: #999999;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex: 1;
        cursor: pointer;
        text-align: center;
        height: 100%;
        transition: all .2s linear;

        &.show{
            display: none;
        }

        &.active{
            color: #323232;
            background-color: #fed800;
        }
    }
}
</style>
